import Model from 'src/storage/base';
import constants from 'src/constants';

const MAX_CHARGE_VALUE = 9999;

class SettingConsultationChargeModel extends Model {
  id = 'SettingConsultationChargeModel';
  persistent = false;
  defaultState = () => ({
    hospitals: [],
    hospital_fees: [],
    charges: [],
    charge: this.chargeObject(),
    followupDuration: 30
  });
  apiConfig = {
    charges: {
      url: 'profile/update/charges',
      validation: {
        charge: 'charge',
        charges: 'charges'
      },
      cancellable: true
    },
    currency: {
      url: 'profile/update/currency',
      validation: {
        currency: 'string'
      },
      cancellable: true
    },
    followupDuration: {
      url: 'profile/update/followupDuration',
      validation: {
        followupDuration: 'number'
      },
      cancellable: true
    },
    add: {
      url: 'profile/add/charge',
      validation: {
        charge: 'charge',
        id: 'baseId'
      },
      cancellable: true
    },
    remove: {
      url: 'profile/remove/charge',
      validation: {
        id: 'baseId'
      },
      cancellable: true
    },
    hospitals: {
      url: 'hospital/list',
      validation: {
        limit: 'number'
      },
      cancellable: true
    },
    doctor_list: {
      url: 'clinic/doctor/list',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    updateFreeChatEnabled: {
      url: 'profile/update/freeChatEnabled',
      validation: {
        target: 'baseId',
        active: 'boolean'
      },
      cancellable: true
    }
  };

  _events = {
    'foxsocket:message:invite': 'onMessageInvite',
    profile: 'handleChangeProfileAndSwitchAccount'
  };

  chargeObject = (id, user) => {
    const state = {
      first: { office: null, virtual: null },
      followup: { office: null, virtual: null },
      chatTicket: {
        price: null,
        duration: null,
        messagesCount: null,
        extraMessage: null,
        paid: false
      }
    };
    if (id) state.id = id;
    if (user) state.user = user;
    return state;
  };

  onLoad = () => {
    if (model.user?.isDoctor) this.loadHospitals();
    else this.loadDoctors();
    this.resetCharges();
  };

  onHandleChangeProfile = () => {
    this.resetCharges();
  };
  loadHospitals = () => {
    this.api(
      'hospitals',
      {
        skip: 0,
        query: '',
        limit: 200
      },
      (err, data) => {
        this.setState({ hospitals: !err ? data?.items || data : [] });
      }
    );
  };
  loadDoctors = () => {
    this.api(
      'doctor_list',
      {
        query: '',
        skip: 0,
        limit: 500,
        joined: true
      },
      (err, data) => {
        this.setState({ doctors: !err ? data?.items || data : [] });
      }
    );
  };

  resetCharges = () => {
    let user = this.state.user || {};
    this.resetApiState('charges');

    const freeChatEnabled = user?.freeChatEnabled || {};

    this.setState({
      currency: user.currency || constants.general.defaultCurrency,
      charge: JSON.parse(JSON.stringify(user.charge ? { ...user.charge } : this.chargeObject())),
      charges: JSON.parse(JSON.stringify(user.charges ? [...user.charges] : [])),
      changed: false,
      followupDuration: user.followupDuration || 30,
      freeForClinics: freeChatEnabled.clinics !== false,
      freeForDoctors: freeChatEnabled.doctors !== false
    });
  };

  saveCharges = (cb) => {
    let req = {
      charge: this.state.charge,
      charges: [...this.state.charges]
    };
    this.api('charges', req, (error, data, success) => {
      if (success) {
        this.emit('profile', data);
      }
      cb && cb(error, data, success);
    });
    if (this.invalid.length) {
      cb(this.invalid);
    }
  };

  addCharge = (charge, cb) => {
    this.api('add', { charge, id: charge.id }, (error, data, success) => {
      if (success) {
        this.emit('profile', data);
      }
      cb && cb(error, data, success);
    });
    if (this.invalid.length) {
      cb(this.invalid);
    }
  };

  removeCharge = (charge, cb) => {
    this.api('remove', { id: charge.id }, (error, data, success) => {
      if (success) {
        this.emit('profile', data);
      }
      cb && cb(error, data, success);
    });
  };

  handleCharges = (id, name, key) => (_, value) => {
    this.log('handleCharges', id, name, key, value);
    if (key !== 'duration' && key !== 'paid') {
      value = parseInt(value) || 0;
      if (value < 0) value = 0;
      if (value > MAX_CHARGE_VALUE) value = MAX_CHARGE_VALUE;
    }
    if (!this.state.changed) this.setStateSilent({ changed: true });
    this.resetApiState('charges');
    if (id === 'default') {
      const charge = this.state.charge;
      if (!charge[name]) charge[name] = {};
      charge[name][key] = value;
      return this.handleChange('charge', charge);
    }
    const charges = this.state.charges.map((charge) => {
      if (charge.id === id) {
        if (!charge[name]) charge[name] = {};
        charge[name][key] = value;
      }
      return charge;
    });

    this.handleChange('charges', charges);
  };

  handleChangeDuration = (followupDuration) => {
    this.handleChange('followupDuration', followupDuration);
    this.api('followupDuration', { followupDuration }, () => {});
  };

  handleChangeCurrency = (currency) => {
    this.handleChange('currency', currency);
    this.api('currency', { currency }, () => {});
  };

  handleFreeChatForDoctorAndClinic = (target, active) => {
    this.handleChange(target, active);
    this.api(
      'updateFreeChatEnabled',
      { target: target === 'freeForDoctors' ? 'doctors' : 'clinics', active },
      () => {}
    );
  };
}

const model = new SettingConsultationChargeModel();
export default model;
